var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSecurity = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 53,
    viewBox: "0 0 50 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 28.1578H27.0833V30.3659H22.9167V28.1578ZM43.75 10.4927V23.7415C43.75 35.8862 35.8333 47.3685 25 50.2391C14.1667 47.3685 6.25 35.8862 6.25 23.7415V10.4927L25 1.66016L43.75 10.4927ZM35.4167 21.5334H30.8333C30.4167 20.2085 29.5833 19.1044 28.5417 18.2212L31.0417 15.5714L29.5833 14.0257L26.6667 17.1171H25C24.5833 17.1171 23.9583 17.1171 23.5417 17.3379L20.625 14.0257L18.9583 15.7922L21.4583 18.442C20.4167 19.1044 19.5833 20.2085 19.1667 21.5334H14.5833V23.7415H18.75V25.9496H14.5833V28.1578H18.75V30.3659H14.5833V32.574H19.1667C20 35.2238 22.2917 36.9903 25 36.9903C27.7083 36.9903 30 35.2238 30.8333 32.574H35.4167V30.3659H31.25V28.1578H35.4167V25.9496H31.25V23.7415H35.4167V21.5334ZM22.9167 25.9496H27.0833V23.7415H22.9167V25.9496Z",
    fill: "#5A23D7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSecurity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/security.6ba1d28603dccb144eea99c4046b802f.svg";